// @ts-nocheck
import getColor from "@insite/mobius/utilities/getColor";
import cssProp from "@toolkit/Framework/Common/Utilities/cssProp";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { css } from "styled-components";

export const countBubblePositionStyles = (position: (string | null)[] | undefined) => {
    return css`
        ${cssProp("top", position?.[0])}
        ${cssProp("right", position?.[1])}
        ${cssProp("bottom", position?.[2])}
        ${cssProp("left", position?.[3])}
    `;
};

export const countBubbleStyles = (position?: (string | null)[], bgColor?: string) => {
    return css`
        ${countBubblePositionStyles(position)}
        position: absolute;
        display: flex; /* Store Custom Code */
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        text-align: center;
        font-size: ${pxToRem(10)};
        width: ${pxToRem(18)}; /* Store Custom Code */
        height: ${pxToRem(18)}; /* Store Custom Code */
        /* Store Removed - padding-top */
        font-weight: ${x => x.theme.design.typography.weight.bold};
        border: ${pxToRem(2)} solid ${getColor("invert") /* Store Custom Code */};
        background-color: ${getColor(bgColor || "tertiary.light") /* Store Custom Code */};
        color: ${getColor("invert") /* Store Custom Code */};
        border-radius: 50%;
        letter-spacing: ${pxToRem(-0.5)};
        /* Store Custom Code - Start */
        padding-right: ${pxToRem(0.5) /* This matches the letter-spacing */};
        align-items: center;
        justify-content: center;
        line-height: 1;
        /* Store Custom Code - End */
    `;
};
